import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import styles from "./login.module.css";
import { useLocation, useNavigate } from "react-router";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { jwtDecode } from "jwt-decode";
import companyStore from "../../Store/Store";
import config from "../../config/config";
import { useSearchParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useDebouncedLog } from "../../useDebouncedLog";

export default function Login() {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [errorMessage, setErrorMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [errorVerification, setErrorVerification] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [session, setSession] = useState(null);
  const [resendClicked, setResendClicked] = useState(false);
  const [generatedUserName, setGeneratedUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [enableResend, setEnableResend] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const navigate = useNavigate();
  const cognitoClient = new CognitoIdentityProviderClient({
    region: "ap-south-1",
  });
  const rawAuth = localStorage.getItem("authToken");
  // const auth = rawAuth ? JSON.parse(rawAuth) : null;
  var logPageVisited;
  var logGetOtpClick;
  var logAutoSendOtp;
  var logAutoVerifySuccess;
  var logAutoFailed;
  var logResendOtp;
  var logVerifyOtpClick;
  try {
    logPageVisited = useDebouncedLog("admin_login_page_visited", 500);
    logGetOtpClick = useDebouncedLog("admin_get_OTP_cta_click", 500);
    logVerifyOtpClick = useDebouncedLog("admin_verify_OTP_cta_click", 500);
    logAutoSendOtp = useDebouncedLog("admin_autologin_send_otp_result", 500);
    logAutoVerifySuccess = useDebouncedLog(
      "admin_autologin_verify_otp_result_success",
      500,
    );
    logAutoFailed = useDebouncedLog("admin_autologin_failed_result", 500);
    logResendOtp = useDebouncedLog("admin_otp_resend_submit_result", 500);
  } catch (err) {
    console.log("error", err);
  }
  let auth = null;
  try {
    const rawAuth = localStorage.getItem("authToken");
    auth = rawAuth ? JSON.parse(rawAuth) : null;
  } catch (e) {
    console.warn("Invalid authToken in localStorage, clearing it");
    localStorage.removeItem("authToken");
    auth = null;
  }

  const location = useLocation();
  const aid = searchParams.get("aid");
  const phNo = searchParams.get("phone_number");
  const cupi_kyc_id = searchParams.get("cupi_kyc_id");
  const company_name = searchParams.get("company_name");
  const company_id = searchParams.get("company_id");
  const cupi_flow = searchParams.get("cupi_flow");

  console.log(
    "encoded_data--->",
    aid,
    cupi_kyc_id,
    company_name,
    company_id,
    cupi_flow,
  );
  function formatIndianPhone(phNo) {
    // strip spaces, dashes, or leading 0
    let cleaned = String(phNo).trim().replace(/[\s-]/g, "").replace(/^0+/, "");

    // add +91 if not already present
    if (!cleaned.startsWith("+91")) {
      cleaned = "+91" + cleaned.replace(/^91/, ""); // remove duplicate 91 if user typed with 91 prefix
    }

    return cleaned;
  }


  const formattedPhNo = formatIndianPhone(phNo);

  useEffect(() => {
    if (aid) {
      // console.log("aid----->",aid);

      setLoading(true);
      console.log("AID", aid);

      testApiKeyLogin(aid, formattedPhNo);
      setLoading(false);
    }
  }, [aid]);

  useEffect(() => {
    logPageVisited();
    // Only navigate if auth is a valid, non-empty object
    if (
      auth &&
      typeof auth === "object" &&
      Object.keys(auth).length > 0 &&
      auth.AccessToken && // Ensure it’s a real auth token
      location.pathname !== "/content"
    ) {

      if (companyStore.Company_Id !== "" && companyStore.Company_Id) {
        navigate("/content");
      } else {
        navigate("/selectCompany");
      }
    } else {
      console.log("Navigation skipped: invalid auth or already on /content");
    }
  }, [logPageVisited]);

  useEffect(() => {
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    try {
      const expired = isTokenExpired(
        parsedTokens?.IdToken ? parsedTokens?.IdToken : "",
      );
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
        if (
          parsedTokens.IdToken &&
          companyStore.Company_Id !== "" &&
          companyStore.Company_Id
        ) {
          navigate("/content");
        }
      }
    } catch (er) {
      console.log("error", er);
    }
  }, []);

  const testApiKeyLogin = async (aid, phNo) => {
    console.log("Testing API Key Login...");
    setLoading(true);
    try {
      const result = await AutosignIn(phNo); //username
      console.log("ress--->", result);

      if (result.challenge) {
        console.log("Handling challenge...11", formattedPhNo, aid);
        const challengeResult = await AutosignIn(
          formattedPhNo,
          null,
          result.session,
          aid,
        );
        console.log(
          "API Key Login Successful:",
          JSON.stringify(challengeResult, null, 2),
        );
        console.log("Token------>:", challengeResult);

        if (challengeResult.tokens) {
          setOtpVerified(true);
          let Idtoken = challengeResult.tokens.IdToken;
          const authToken = {
            AccessToken: challengeResult.tokens.AccessToken,
            RefreshToken: challengeResult.tokens?.RefreshToken,
            IdToken: challengeResult.tokens.IdToken,
          };
          let token = jwtDecode(Idtoken);
          console.log("token", token);

          // Check custom:cupi_admin and custom:cupi_owner
          const isAdmin =
            token["custom:cupi_admin"] && token["custom:cupi_admin"] !== "[]";
          const isOwner =
            token["custom:cupi_owner"] && token["custom:cupi_owner"] !== "[]";

          localStorage.removeItem("authToken");

          // Allow access if either admin or owner role exists
          if (isAdmin || isOwner) {
            localStorage.setItem("authToken", JSON.stringify(authToken));
            console.log("User is authorized as:", isAdmin ? "Admin" : "Owner");
            // companyStore.setUserType("PineLabUser");
            console.log("OTP verified successfully!");
            console.log(
              `/selectCompany?cupi_kyc_id=${cupi_kyc_id}&company_name=${company_name}&ledger_label=${company_id}&cupi_flow=${cupi_flow}`,
            );

            navigate(
              `/selectCompany?cupi_kyc_id=${cupi_kyc_id}&company_name=${company_name}&ledger_label=${company_id}&cupi_flow=${cupi_flow}`,
            );
            setLoading(false);
          }
        }
      } else if (result.success) {
        console.log("Direct Success:", JSON.stringify(result.tokens, null, 2));
        setLoading(false);
      } else {
        console.log("Unexpected response:", JSON.stringify(result, null, 2));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("API Key Login Error:", error.message);
    }
  };

  const isTokenExpired = (token) => {
    try {
console.log("token",token);
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      localStorage.removeItem("tradeName");
      localStorage.removeItem("authToken");
      localStorage.removeItem("Company_Id");
      localStorage.removeItem("CompanyName");
      localStorage.removeItem("email");
      localStorage.removeItem("KycCompanyId");
      localStorage.removeItem("company_temp_id");
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  async function AutosignIn(
    username,
    otp = null,
    session = null,
    aid,
    clientId = "21k0cgope0hvi22dikd805pbes",
    //21k0cgope0hvi22dikd805pbes//PRODUCTION
    //5kuv08g29sma5deevjie4tlqc7//TESTING
  ) {
    try {
      setLoading(true);
      console.log("userName--->", username);
      console.log("aid", aid);

      if (!username) throw new Error("username is required");

      if (!session) {
        //No session Token available So Initiate AUTH
        const params = {
          AuthFlow: "CUSTOM_AUTH",
          ClientId: clientId,
          AuthParameters: { USERNAME: username },
        };

        console.log("InitiateAuth params:", JSON.stringify(params, null, 2));
        const command = new InitiateAuthCommand(params);
        const authResponse = await cognitoClient.send(command);
        console.log(
          "InitiateAuth response:",
          JSON.stringify(authResponse, null, 2),
        );
        logAutoSendOtp();

        companyStore.setEmail(authResponse?.ChallengeParameters?.USERNAME);
        if (authResponse.AuthenticationResult) {
          return { success: true, tokens: authResponse.AuthenticationResult };
        }

        if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
          return {
            success: false,
            challenge: true,
            session: authResponse.Session,
            challengeParameters: authResponse.ChallengeParameters || {},
          };
        }
        setLoading(false);
        throw new Error("Unexpected response from InitiateAuth");
      } else {
        //session Token available So Verify AUTH
        setLoading(true);
        const obj = {
          userAnswer: aid, // aid to get from the backend for the first Auto login
        };
        const params = {
          ChallengeName: "CUSTOM_CHALLENGE",
          ClientId: clientId,
          Session: session,
          ChallengeResponses: {
            USERNAME: username,
            ANSWER: JSON.stringify(obj),
          },
        };
        const command = new RespondToAuthChallengeCommand(params);
        const challengeResponse = await cognitoClient.send(command);
        console.log(
          "RespondToAuthChallenge response:",
          JSON.stringify(challengeResponse, null, 2),
        );

        if (challengeResponse.AuthenticationResult) {
          return {
            success: true,
            tokens: challengeResponse.AuthenticationResult,
          };
        }
        logAutoVerifySuccess();

        setLoading(false);
        throw new Error("Challenge response failed");
      }
    } catch (error) {
      setLoading(false);
      logAutoFailed();
      console.log("Authentication error:", error);
      throw new Error(`Authentication failed: ${error.message}`);
    }
  }

  const sendOtp = async () => {
    if (
      email[0] != "6" &&
      email[0] != "7" &&
      email[0] != "8" &&
      email[0] != "9"
    ) {
      setErrorMessage("Phone number is a required field");
    }
    if (email === "") {
      setErrorMessage("Phone number is a required field");
      return;
    }
    let loginNumber = `+91${email}`;
    console.log("verify validity");

    if (!isValidIndianPhoneNumber(loginNumber)) {
      console.log("invalid phonenumber");

      return;
    }

    try {
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: config.Client_Id, // App client ID
        AuthParameters: { USERNAME: loginNumber },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      setEnableResend(false);
      ShowResend();
      console.log("Auth Response:", authResponse);

      logGetOtpClick();

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        setOtpSent(true);
        companyStore.setEmail(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
        setErrorVerification("");
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This phone number is not registered");
      console.log("Error during sending OTP:", error);
    }
  };

  const reset = () => {
    setStep(1);
    setOtp(Array(6).fill(""));
  };

  function isValidIndianPhoneNumber(phone) {
    // Regex pattern for Indian phone numbers
    const indianPhoneRegex = /^\+91[ -]?(?:[6-9]\d{9})$/;

    if (indianPhoneRegex.test(phone)) {
      return true;
    } else {
      setErrorMessage("Please enter a valid phone number");
      return false;
    }
  }

  const verifyOtp = async () => {
    const otpString = otp.join("");
    if (otpString == "") {
      setErrorVerification("OTP is a required field");
      return;
    }
    if (otpString.length != 6) {
      setErrorVerification("Invalid OTP");
      return;
    }
    let loginNumber = `+91${email}`;
    try {
      const params = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ClientId: config.Client_Id,
        ChallengeResponses: {
          USERNAME: loginNumber,
          ANSWER: otpString,
        },
        Session: session,
      };

      const command = new RespondToAuthChallengeCommand(params);
      const verifyResponse = await cognitoClient.send(command);
      console.log("Verify Response:", verifyResponse);

      if (verifyResponse.AuthenticationResult) {
        setOtpVerified(true);
        let Idtoken = verifyResponse.AuthenticationResult.IdToken;
        const authToken = {
          AccessToken: verifyResponse.AuthenticationResult.AccessToken,
          RefreshToken: verifyResponse.AuthenticationResult?.RefreshToken,
          IdToken: verifyResponse.AuthenticationResult.IdToken,
        };
        let token = jwtDecode(Idtoken);
        console.log("token", token);

        // Check custom:cupi_admin and custom:cupi_owner
        const isAdmin =
          token["custom:cupi_admin"] && token["custom:cupi_admin"] !== "[]";
        const isOwner =
          token["custom:cupi_owner"] && token["custom:cupi_owner"] !== "[]";
        const isEsViewAdmin = token["custom:es_view_admin"]
          ? token["custom:es_view_admin"] == "true"
          : false;
        localStorage.removeItem("authToken");
        const isEsAdmin = token["custom:es_admin"]
          ? token["custom:es_admin"] == "true"
          : false;
        const isViewAdmin =
          token["custom:cupi_view_admin"] &&
          token["custom:cupi_view_admin"] !== "[]";

        // Allow access if either admin or owner role exists
        if (isAdmin || isOwner || isEsViewAdmin || isEsAdmin || isViewAdmin) {
          localStorage.setItem("authToken", JSON.stringify(authToken));
          console.log("User is authorized as:", isAdmin ? "Admin" : "Owner");
          // companyStore.setUserType("PineLabUser");
          console.log("OTP verified successfully!");
          navigate("/selectCompany");
        } else {
          console.log("UNAUTHORIZED.");
          setErrorVerification(
            "You are not authorized to access the CUPI Dashboard.",
          );
          // alert("UNAUTHORIZED.");

          return;
        }
      } else {
        setOtpVerified(false);
        setErrorVerification("Oops! Incorrect OTP. Please try again.");
      }
      logVerifyOtpClick();
    } catch (error) {
      // resendOtp();
      setErrorVerification("Oops! Incorrect OTP. Please try again.");
      console.log("Error during OTP verification:", error);
    }
  };

  const resendOtp = async () => {
    try {
      let loginNumber = `+91${email}`;
      const params = {
        AuthFlow: "CUSTOM_AUTH",
        ClientId: config.Client_Id, // App client ID
        AuthParameters: {
          USERNAME: loginNumber,
          PASSWORD: "YourHardcodedPassword", // Hardcoded password for step 1
        },
      };

      const command = new InitiateAuthCommand(params);
      const authResponse = await cognitoClient.send(command);
      setEnableResend(false);
      ShowResend();
      console.log("Auth Response:", authResponse);

      logResendOtp();

      if (authResponse.ChallengeName === "CUSTOM_CHALLENGE") {
        setOtpSent(true);
        companyStore.setEmail(loginNumber);
        setSession(authResponse.Session);
        setGeneratedUserName(authResponse.ChallengeParameters.USERNAME);
        console.log("OTP has been sent to the user!");
        setStep(2);
      }
    } catch (error) {
      console.log("Error during sending OTP:", error.name);
      setErrorMessage("This Phone number is not registered");
      console.log("Error during sending OTP:", error);
    }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const ShowResend = async () => {
    console.log("enabeling new otp in few seconds");

    for (let i = 45; i >= 0; i--) {
      setTimer(i);
      if (i >= 0) {
        //resend enable
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    setEnableResend(true);
    console.log("Resend OTP Enabled");
    return;
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress size={60} sx={{ color: "#2348AB" }} />
        </div>
      )}
      <div className={styles.logincontainer}>
        <div className={styles.card}>
          <div className={styles.finalCupiLogo}>
            <img className={styles.frameChild} alt="" src="/Final_Cupi.svg" />
          </div>
          <div className={styles.welcomeToEscrowStackParent}>
            {/* <div className={styles.welcomeToEscrow}>Welcome to Escrow Stack</div> */}
            <div className={styles.pleaseSignInTo}>
              Please sign-in to continue
            </div>
          </div>
          {step === 1 && (
            <div className={styles.inputoutlinedParent}>
              <TextField
                className={styles.inputoutlined}
                color="primary"
                value={email}
                Length={13}
                onChange={(event) => {
                  setEmail(event.target.value);
                  setErrorMessage("");
                }}
                inputProps={{ maxLength: 10 }}
                label="Enter Phone Number"
                size="medium"
                variant="outlined"
                type="email"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "58px",
                    borderRadius: "12px",
                  },
                }}
              />
              {<div className={styles.error}>{errorMessage}</div>}
              <button
                className={styles.getOtp}
                onClick={() => {
                  sendOtp();
                }}
              >
                <b className={styles.getOtp1}>Get OTP</b>
              </button>
            </div>
          )}
          {step === 2 && (
            <div className={styles.inputoutlinedParent}>
              <div className={styles.welcomeToEscrowotp}>Enter OTP</div>
              <div className={styles.otpInputs}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => {
                      setErrorMessage("");
                      setErrorVerification("");
                      setResendClicked(false);
                      handleKeyDown(e, index);
                    }}
                    className={
                      errorVerification != ""
                        ? styles.invalidotpInput
                        : styles.otpInput
                    }
                  />
                ))}
              </div>
              {resendClicked && (
                <div className={styles.resendOtp}>
                  A new OTP has been sent to you.
                </div>
              )}
              {errorVerification != "" && (
                <div className={styles.invalidotp}>{errorVerification}</div>
              )}
              {enableResend ? (
                <button
                  className={styles.welcomeToEscrowotpbtn}
                  onClick={() => {
                    setResendClicked(true);
                    setErrorVerification("");
                    resendOtp();
                  }}
                >
                  Resend OTP
                </button>
              ) : (
                <div className={styles.welcomeToEscrowot} onClick={() => {}}>
                  {`Resend OTP in ${timer}`}
                </div>
              )}
              <button
                className={styles.getOtp}
                onClick={() => {
                  verifyOtp();
                }}
              >
                <b className={styles.getOtp1}>Verify OTP</b>
              </button>

              <div className={styles.arrow}>
                <div
                  className={styles.arrow1}
                  onClick={() => {
                    setErrorVerification("");
                    setResendClicked(false);
                    reset();
                  }}
                >
                  <img
                    className={styles.frameChildarrow}
                    alt=""
                    src="/arrownarrowleft.svg"
                  />
                  <b className={styles.getOtp1arrow}>Back</b>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
